import { Button, Link, Paper, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";

export function NotFound() {
    const navigate = useNavigate();

    return (
        <div>
            <div style={{ position: 'absolute', left: '50%', top: '50%', WebkitTransform: "Translate(-50%, -50%)", transform: "transform(-50%, -50%)" }}>
                <Paper variant="outlined" style={{ padding: "30px", textAlign: 'center' }}>

                    <Typography variant="h1" component="h2" gutterBottom>
                        404
                    </Typography>

                    <Typography variant="h2" component="h2" gutterBottom>
                        Page Not Found
                    </Typography>

                    <Typography variant="h6" component="h2" gutterBottom>
                        If you believe this is a mistake, please contact our&nbsp;
                        <Link
                            href="#"
                            onClick={(e) => {e.preventDefault();}}
                            color="primary"
                            underline="hover">
                            support team
                        </Link>
                    </Typography>
                    <br />
                    <br />
                    <Button variant='contained' color='primary' onClick={() => navigate("/")}>Go Home</Button>
                </Paper>
            </div>
        </div>
    );
}